@if (userSession) {
  <div class="body-container">
    @if (isSidebarOpen && isMobile) {
      <div class="sidebar-overlay" (click)="toggleSidebar()"></div>
    }
    <div class="side-bar-container" [class.closed]="!isSidebarOpen">
      <app-sidebar [isOpen]="isSidebarOpen" [isMobile]="isMobile"></app-sidebar>
    </div>

    <div class="main-container">
      <app-loading></app-loading>
      <app-toolbar (toggleMenu)="toggleSidebar()"></app-toolbar>

      <div class="content-wrapper">
        <div class="content-inner">
          <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
